import React from 'react';
import TimecardRequestForm from '../../components/mobile/m-timecard-request/TimecardRequestForm';

const TimecardRequest: React.FC = () => {
  return <TimecardRequestForm />;
};

export default TimecardRequest;
